<div class="dialog">
  @if (isMobileView) {
    <header class="mobile-app-bar">
      <p (click)="close()" [ngStyle]="{ cursor: 'pointer' }" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ 'New Chat' | translate }}</h2>
      <p [ngStyle]="{ cursor: 'pointer' }" class="disabled" disabled="true" translate>Save</p>
    </header>
  }

  @if (!isMobileView) {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'New Chat' | translate }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px', cursor: 'pointer' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div [class.pt-0]="isMobileView" class="dialog__content">
    <form [formGroup]="form">
      <!-- Chat Type -->
      <div class="input-group --required">
        <label for="type" translate>Type</label>
        <app-dropdown [options]="chatTypes" bindValue="value" displayName="key" formControlName="type" id="type" name="type"></app-dropdown>
        <app-form-error [control]="form.get('type')" [name]="'Type' | translate"></app-form-error>
      </div>

      <!-- Users -->
      @if (form.get('type').value === ChatType.PERSONAL_CHAT) {
        <div class="input-group --required">
          <label for="user" translate>User</label>
          <ng-select
            [closeOnSelect]="true"
            [items]="teamUsers"
            [multiple]="false"
            [placeholder]="'User' | translate"
            [searchable]="true"
            bindLabel="fullName"
            bindValue="id"
            class="custom"
            formControlName="friendUid"
            id="user"
            name="user"
          ></ng-select>
          <app-form-error [control]="form.get('user')" [name]="'User' | translate"></app-form-error>
        </div>
      }

      <!-- Groups -->
      @if (form.get('type').value === ChatType.GROUP_CHAT) {
        <div class="input-group --required">
          <label for="group" translate>Group</label>
          <ng-select
            [closeOnSelect]="true"
            [items]="groupsForUser"
            [multiple]="false"
            [placeholder]="'Group' | translate"
            [searchable]="true"
            bindLabel="name"
            bindValue="id"
            class="custom"
            formControlName="friendUid"
            id="group"
            name="group"
          ></ng-select>
          <app-form-error [control]="form.get('user')" [name]="'User' | translate"></app-form-error>
        </div>
      }

      <!-- Message -->
      <div class="input-group --required">
        <label for="message" translate>Message</label>
        <textarea [placeholder]="'Message' | translate" class="full-width-input" formControlName="message" id="message" name="message" rows="3"></textarea>
        <app-form-error [control]="form.get('message')" [name]="'Message' | translate"></app-form-error>
      </div>

      <!-- Choose File -->
      <app-file-selector-input (attachmentSelected)="selectedAttachment = $event" [accept]="acceptFileTypes"></app-file-selector-input>
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="'Send' | translate"></app-button>
        </div>
      }
    </div>
    @if (isMobileView) {
      <div class="mobile-button mx-16 mb-34">
        <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="'Send' | translate" cssClass="button-primary button-full"></app-button>
      </div>
    }
  </footer>
</div>
